import { graphql, useStaticQuery } from 'gatsby';

export default function useSiteConfig() {
  const siteConfig = useStaticQuery(query);
  return afterQuery(siteConfig);
}

export const query = graphql`
  query SiteConfig {
    site {
      siteMetadata {
        tastingNotesEnabled
      }
    }
  }
`;

function afterQuery({ site }) {
  return {
    tastingNotesEnabled: Boolean(site?.siteMetadata?.tastingNotesEnabled),
  };
}
